module.exports = __webpack_public_path__ + "img/competencies.159f7815.svg";